import * as axios from "axios";
import { getAuthHeader } from "../utils";

export const addFile = (model) => {
  const url = `${process.env.REACT_APP_BASE_URL}knowledge-management/add`;
  return axios
    .post(url, model, getAuthHeader())
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      alert(error.message);
    });
};

export const searchFile = (searchTerm) => {
  const url = `${process.env.REACT_APP_BASE_URL}knowledge-management/search?searchTerm=${searchTerm}`;
  return axios.get(url, getAuthHeader()).then(
    (response) => {
      return response.data;
    },
    (error) => {
      alert(error.Message);
    }
  );
};

export const deleteFile = (id) => {
  const url = `${process.env.REACT_APP_BASE_URL}knowledge-management/delete/${id}`;
  return axios.delete(url, getAuthHeader()).then(
    (response) => {
      return response.data;
    },
    (error) => {
      alert(error.Message);
    }
  );
};

export const getKMFileList = () => {
  const url = `${process.env.REACT_APP_BASE_URL}knowledge-management/file/list`;
  return axios.get(url, getAuthHeader()).then(
    (response) => {
      return response.data;
    },
    (error) => {
      alert(error.Message);
    }
  );
};
